import styled from "styled-components";

export default styled.div`
  & {
    .preview-parent {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 4px;
      margin-top: 6px;
    }

    .preview-left {
      display: flex;
      flex-direction: column;
      gap: 4px;

      p {
        margin: 0px;
      }
    }

    .file-name {
      font-size: larger;
      font-weight: 700;
    }
    .file-size {
      font-size: small;
      font-weight: 400;
    }

    .ellipsis {
      font-size: 14px;
      font-weight: 400;
      margin: 0px 2px;
    }
    .trash {
      all: unset;
      color: #f45e5e;
      cursor: pointer;
      pointer-events: auto;
      transition: all 300ms;
    }
    .trash:hover {
      filter: brightness(0.9) saturate(0.8);
      transform: scale(1.1);
    }

    .trash:focus {
      outline: 2px solid #f45e5e;
    }

    .trash:active {
      filter: brightness(0.75) saturate(0.7);
      transform: scale(1);
    }

    .removeLabel {
      display: flex;
      justify-content: center;
      color: red;
      width: 200px;
      font-size: 12px;
      margin-top: 6px;
    }
  }
`;
